import get from 'lodash/get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect, Switch } from 'react-router-dom';

import BrokerFormContainer from './BrokerFormContainer';
import VisitorFormContainer from './VisitorFormContainer';

import { isAdmin, isPM } from '../../utils';

import Route from '../../routes/SentryRoute';

const ManageVisitorRouterComponent = (props) => {
  const {
    pmc,
    pmcId,
    building,
    buildingId,
    match: { path, url, params },
  } = props;

  const isBrokerAvailable = isAdmin() || isPM(params);

  if (buildingId && !building) {
    return null;
  }
  if (pmcId && !pmc) {
    return null;
  }

  return (
    <section>
      <Switch>
        <Route
          path={`${path}/update-visitor/:visitorId`}
          component={VisitorFormContainer}
        />
        <Route
          path={`${path}/update-prospective-tenant/:visitorId`}
          component={VisitorFormContainer}
        />
        {isBrokerAvailable && (
          <Route
            path={`${path}/update-broker/:brokerId`}
            component={BrokerFormContainer}
          />
        )}
        <Route
          path={`${path}/create-visitor`}
          component={VisitorFormContainer}
        />
        {isBrokerAvailable && (
          <Route
            path={`${path}/create-broker`}
            component={BrokerFormContainer}
          />
        )}
        <Route
          path={`${path}`}
          render={() => <Redirect to={`${url}/create-visitor/`} />}
        />
      </Switch>
    </section>
  );
};

ManageVisitorRouterComponent.defaultProps = {
  pmc: null,
  building: null,
  pmcId: null,
  buildingId: null,
};

ManageVisitorRouterComponent.propTypes = {
  pmc: PropTypes.instanceOf(Object),
  building: PropTypes.instanceOf(Object),
  match: PropTypes.instanceOf(Object).isRequired,
  pmcId: PropTypes.string,
  buildingId: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => {
  const { pmcs, buildings } = state;
  const buildingId = get(ownProps, 'match.params.buildingId');
  const pmcId = get(ownProps, 'match.params.PMCId');
  const building = buildingId && buildings[buildingId];
  const pmc = pmcId && pmcs[pmcId];
  return { pmc, building, buildingId, pmcId };
};

export default connect(mapStateToProps, null)(ManageVisitorRouterComponent);
